import { TextField } from '@mui/material';
import { PlaceFormData } from '@/hooks/usePlaceForm';

interface PlaceFormFieldsProps {
  formData: PlaceFormData;
  errors: Record<string, string>;
  onChange: (name: string, value: any) => void;
}

const focusStyles = {
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': { borderColor: 'primary.main' },
    '&.Mui-focused fieldset': { borderWidth: 2, borderColor: 'primary.main' },
  },
};

export const PlaceFormFields = ({ formData, errors, onChange }: PlaceFormFieldsProps) => {
  return (
    <>
      <TextField
        label="Name"
        name="name"
        value={formData.name}
        onChange={(e) => onChange('name', e.target.value)}
        fullWidth
        required
        margin="normal"
        error={!!errors.name}
        helperText={errors.name}
        sx={focusStyles}
      />
      <TextField
        label="Description"
        name="description"
        value={formData.description}
        onChange={(e) => onChange('description', e.target.value)}
        fullWidth
        required
        multiline
        rows={4}
        margin="normal"
        error={!!errors.description}
        helperText={errors.description}
        sx={focusStyles}
      />
    </>
  );
};
